import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from "@ngrx/store";
import { map } from "rxjs/operators";
import { brandingFeature } from "src/app/state/branding.store";
import { getZoneActivePrice } from "src/app/utilities/product.util";

import { JobMutateChargeActions } from "./mutate-charges.actions";

export const addCharges = createEffect((
  actions$ = inject(Actions),
  store = inject(Store),
) => {
    return actions$.pipe(
      ofType(JobMutateChargeActions.productSelected),
      concatLatestFrom(() => store.select(brandingFeature.selectBranding)),
      map(([ { selectedProduct }, { zoneId } ]) => JobMutateChargeActions.productWithPriceSelected({
        selectedProduct,
        price: getZoneActivePrice(selectedProduct.prices, zoneId),
      })),
    );
  }, { functional:true, dispatch: true });
